<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">Agenda</h4>
    </div>
    <div class="col-lg-12 card card-calendar ">
      <div class="card-body row">
        <div id="fullCalendar" ref="calendar"></div>
        <div v-if="riduser == 1">
          Légende : 
          <span class="badge" v-for="contact in contacts" :key="contact.coid"  :style="contact.style">
            {{ contact.commercial }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import { Calendar } from 'fullcalendar'
  import frLocale from 'fullcalendar/dist/locales/fr';
  import {Select, Option} from 'element-ui'
  import VueJwtDecode from 'vue-jwt-decode'

  const today = new Date();
  const y = today.getFullYear();
  const m = today.getMonth();
  const d = today.getDate();
  export default {
    data() {
      return {
        events: [],
        contacts: [],
        riduser:VueJwtDecode.decode(localStorage.getItem('token')).id.rid
      }
    },
    methods: {
      async initCalendar() {
        this.events = []
        const self = this;
        const response = await fetch(this.$api_url+'/agenda', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            self.log_api("success",'GET /agenda', '', json)
            Object.keys(json).forEach(function (key) {
              self.events.push({
                title: json[key].company,
                start: new Date(json[key].date_rdv * 1000),
                commercial: json[key].com_firstname+' '+json[key].com_lastname,
                agid: json[key].agid,
                adid: json[key].adid,
                backgroundColor: json[key].couleur_agenda,
                textColor: 'black'
              });
            })
          } else { 
            router.push("login")    
          }
        }
        let $calendar = new Calendar(this.$refs.calendar, {
          header: {
            left: 'title',
            center: '',
            right: 'prev,next,today'
          },
          height:"auto",
          defaultDate: today,
          selectable: true,
          selectHelper: true,
          aspectRatio: 2.6,
          views: {
            month: {
              titleFormat: {
                month: 'long',
                year: 'numeric'
              }
            }
          },
          locale: frLocale,
          eventClick: async function(event) {
            const response = await fetch(self.$api_url+'/agenda/'+event.event.extendedProps.agid, {
              method: 'GET',
              credentials: 'include',
            });
            if(response.ok) { 
              var json = await response.json();
              //check if api return regenerated token
              if(json.code != 409) {
                  self.log_api("success",'GET /agenda/'+event.event.extendedProps.agid, '', json)
                  let dateStart = new Date(json.date_rdv*1000); 
                  let day = ('00' + dateStart.getDate()).slice(-2)
                  let month = ('00' + eval(dateStart.getMonth()+1)).slice(-2)
                  let year = dateStart.getFullYear()
                  let hours = ('00' + dateStart.getHours()).slice(-2)
                  let minutes = ('00' + dateStart.getMinutes()).slice(-2)
                  let options_list = ''
                  let options_list_contact = ''
                  json.adresses.forEach(key => {
                    let selected = '';
                    if(key.adid == event.event.extendedProps.adid) {
                      selected = 'selected'
                    }
                    options_list += '<option value="'+key.adid+'" '+selected+'>'+key.address+' '+key.zipcode+' '+key.city+'</option>'
                  })
                  json.allcontacts.forEach(key => {
                    let selected_contact = '';
                    if(key.coid == json.coid) {
                      selected_contact = 'selected'
                    }
                    options_list_contact += '<option value="'+key.coid+'" '+selected_contact+'>'+key.firstname+' '+key.lastname+'</option>'
                  })
                  let html = '<center>'
                  if(VueJwtDecode.decode(localStorage.getItem('token')).id.rid == 1) {
                    html += '<b>Commercial :</b>'+
                    '<select class="form-control" id="select-coid">'+
                    options_list_contact +
                    '</select>'
                  }
                  html += '<br><b>Date du rendez-vous :</b>'+
                    '<input type="datetime-local" value="'+year+'-'+month+'-'+day+'T'+hours+':'+minutes+'" class="form-control" id="input-date"><br>'+
                    
                    '<b>Titre :</b>'+
                    '<input type="text" class="form-control" id="input-titre" value="'+json.titre+'" /><br>' +
                    
                    '<b>Commentaire :</b>'+
                    '<textarea class="form-control" id="input-commentaire">'+json.commentaire+'</textarea><br>' +
                  
                    '<b>Adresse du rendez-vous :</b>'+
                    '<select class="form-control" id="select-adid">'+
                    options_list +
                    '</select>'+
                    '<a target="_blank" href="https://www.google.com/maps/place/'+encodeURI(json.address+' '+json.zipcode+' '+json.city)+'">Ouvrir dans Google Maps</a>'+
                    
                    '<br><br>'+
                    '<b>Appeler le client :</b>'+
                    '<br> <a href="tel:'+json.phone+'">'+json.phone+'</a>'

                  let evenement = await swal({
                    title: 'Rendez-vous avec '+json.company,
                    html: html,
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success',
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i> Enregistrer',
                    cancelButtonClass: 'btn btn-danger',
                    cancelButtonText: 'Annuler',
                    buttonsStyling: false
                  });
                  if(evenement) { 
                    let date_rdv = Math.round(new Date(document.getElementById('input-date').value).getTime()/1000)
                    const params = new URLSearchParams();
                    params.append('agid', json.agid);
                    params.append('cid', json.cid);
                    if(VueJwtDecode.decode(localStorage.getItem('token')).id.rid == 1) {
                      params.append('coid', document.getElementById('select-coid').value);
                    } else {
                      params.append('coid', 'connectedone');
                    }
                    params.append('date_add', json.date_add);
                    params.append('date_rdv', date_rdv);
                    params.append('titre', document.getElementById('input-titre').value);
                    params.append('commentaire', document.getElementById('input-commentaire').value);
                    params.append('adid', document.getElementById('select-adid').value);

                    const response2 = await fetch(self.$api_url+'/agenda', {
                      method: 'PUT',
                      credentials: 'include',
                      body: params
                      });
                    const json2 = await response2.json();
                    if(json2.hasOwnProperty('rows')) {
                      self.log_api("success",'PUT /agenda', json2)
                      $calendar.destroy();
                      self.initCalendar();
                    }
                  }
              } else { 
                router.push("login")    
              }
            }
            
          },
          eventLimit: true, // allow "more" link when too many events

          // color classes: [ event-blue | event-azure | event-green | event-orange | event-red ]
          events: self.events
        });
        $calendar.render();
      },
      async initContacts() {
        const self = this;
        const response = await fetch(this.$api_url+'/contacts', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            self.log_api("success",'GET /contacts', '', json)
            Object.keys(json).forEach(function (key) {
              self.contacts.push({
                uid: json[key].uid,
                commercial: json[key].firstname+' '+json[key].lastname,
                style: 'padding:5px;margin:5px;font-weight:normal;color:black;background-color:'+json[key].couleur_agenda
              })
            })
          }
        }
      }
    },
    async mounted() {
      this.initCalendar();
      this.initContacts();
    }
  }
</script>
<style>
  #fullCalendar {
    min-height: 300px;
  }

  .el-loading-spinner .path {
    stroke: #66615B !important;
  }
</style>